import React, {
  ChangeEvent,
  useRef,
  useCallback,
  useImperativeHandle,
  forwardRef,
  useEffect,
} from 'react';
import styles from './index.module.less';
import Icon from '@/components/Icon';
import debounce from 'lodash/debounce';
import { useTranslation } from 'react-i18next';

export interface FowardProps {
  blur: () => void;
}

interface IProps {
  onFocus?: () => void;
  onChange?: (e: string) => void;
  onClear?: () => void;
  placeholder?: string;
  value?: string;
  autoFocus?: boolean;
}

const SearchInput: React.ForwardRefRenderFunction<FowardProps, IProps> = (
  {
    onFocus,
    onChange,
    onClear,
    placeholder = 'type_in_question',
    value,
    autoFocus = false,
  },
  ref,
) => {
  const inputRef = useRef(null);
  const handleClear = useCallback(() => {
    inputRef.current.value = '';
    onClear && onClear();
  }, [onClear]);

  const { t } = useTranslation();

  // debounce
  const setSearchValue = (e: ChangeEvent<HTMLInputElement>) => {
    searchDebounce(e.target.value);
  };
  const searchDebounce = debounce((_value: string) => {
    onChange && onChange(_value);
  }, 500);

  useImperativeHandle(ref, () => ({
    blur: () => inputRef.current.blur(),
  }));

  useEffect(() => {
    if (value) {
      inputRef.current.value = value;
    }
  }, [value]);

  return (
    <div className={styles.searchBox}>
      <Icon iconName={'search'} />
      <input
        placeholder={t(placeholder)}
        onFocus={onFocus}
        onChange={setSearchValue}
        ref={inputRef}
        autoFocus={autoFocus}
      />
      {Boolean(value) && (
        <div onClick={handleClear}>
          <Icon iconName={'close'} />
        </div>
      )}
    </div>
  );
};

export default forwardRef(SearchInput);
